import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { FlagIcon } from "../Icon/FlagIcon/FlagIcon";
import { Link } from "../Button/Link/Link";
import styles from "./CountryLink.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CountryLink = function CountryLink(_ref) {
  var flag = _ref.flag,
    link = _ref.link,
    text = _ref.text;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.countryLink,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.countryLinkFlag,
      children: /*#__PURE__*/_jsx(FlagIcon, _objectSpread({}, flag))
    }), /*#__PURE__*/_jsx("div", {
      className: styles.countryLinkText,
      children: /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, link), {}, {
        children: text
      }))
    })]
  });
};